export class StaffAvailableModel {
 fromDate: string;
 remark: string;
staffId: number;
toDate: string
id:number
}                      

